 <div *ngIf="isZeroStar">
    <span class="fa fa-star fa-2x text-secondary"></span>
    <span class="fa fa-star fa-2x text-secondary"></span>
    <span class="fa fa-star fa-2x text-secondary"></span>
    <span class="fa fa-star fa-2x text-secondary"></span>
    <span class="fa fa-star fa-2x text-secondary"></span>
</div>
<div *ngIf="isOneStar">
<span class="fa fa-star fa-2x star-checked"></span>
<span class="fa fa-star fa-2x text-secondary"></span>
<span class="fa fa-star fa-2x text-secondary"></span>
<span class="fa fa-star fa-2x text-secondary"></span>
<span class="fa fa-star fa-2x text-secondary"></span>
</div>

<div *ngIf="isTwoStar">
<span class="fa fa-star fa-2x star-checked"></span>
<span class="fa fa-star fa-2x star-checked"></span>
<span class="fa fa-star fa-2x text-secondary"></span>
<span class="fa fa-star fa-2x text-secondary"></span>
<span class="fa fa-star fa-2x text-secondary"></span>
</div>

<div *ngIf="isThreeStar">
<span class="fa fa-star fa-2x star-checked"></span>
<span class="fa fa-star fa-2x star-checked"></span>
<span class="fa fa-star fa-2x star-checked"></span>
<span class="fa fa-star fa-2x text-secondary"></span>
<span class="fa fa-star fa-2x text-secondary"></span>
</div>

<div *ngIf="isFourStar">
<span class="fa fa-star fa-2x star-checked"></span>
<span class="fa fa-star fa-2x star-checked"></span>
<span class="fa fa-star fa-2x star-checked"></span>
<span class="fa fa-star fa-2x star-checked"></span>
<span class="fa fa-star fa-2x text-secondary"></span>
</div>
<div *ngIf="isFiveStar">
<span class="fa fa-star fa-2x star-checked"></span>
<span class="fa fa-star fa-2x star-checked"></span>
<span class="fa fa-star fa-2x star-checked"></span>
<span class="fa fa-star fa-2x star-checked"></span>
<span class="fa fa-star fa-2x star-checked"></span>
</div>
